export const CatError = () => {
    return (
        <svg width="192" height="104" viewBox="0 0 192 104" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.5298 22.081C12.5298 10.9906 21.5204 2 32.6108 2H80.2999C84.5599 2 88.0133 5.45342 88.0133 9.71343C88.0133 13.9734 91.4667 17.4269 95.7267 17.4269H165.082C176.173 17.4269 185.163 26.4174 185.163 37.5078V77.2851C185.163 88.3755 176.173 97.3661 165.082 97.3661H74.0717C67.8753 97.3661 62.8521 92.3429 62.8521 86.1466C62.8521 79.9502 57.829 74.927 51.6326 74.927H32.6108C21.5204 74.927 12.5298 65.9365 12.5298 54.846V22.081Z"
                fill="#F3EFEC"
            />
            <path
                d="M4.44095 51.4557H21.1905C23.6488 51.4557 25.6314 49.3616 25.6314 46.765C25.6314 44.1683 23.6488 42.0742 21.1905 42.0742H4.44095C1.98257 42.0742 0 44.1683 0 46.765C0 49.3616 1.99578 51.4557 4.44095 51.4557Z"
                fill="#FFC2B0"
            />
            <path
                d="M177.771 84.1725H187.559C190.017 84.1725 192 82.0784 192 79.4818C192 76.8851 190.017 74.791 187.559 74.791H177.771C175.312 74.791 173.33 76.8851 173.33 79.4818C173.33 82.0784 175.325 84.1725 177.771 84.1725Z"
                fill="#FFC2B0"
            />
            <path
                d="M151.687 20.5881C151.961 20.3178 152.402 20.3202 152.672 20.5936C152.942 20.8669 152.94 21.3077 152.666 21.578L144.747 29.4095L143.768 28.4196L151.687 20.5881Z"
                fill="#3B3B3B"
            />
            <path
                d="M131.693 20.5881C131.42 20.3178 130.979 20.3202 130.709 20.5936C130.439 20.8669 130.441 21.3077 130.715 21.578L138.634 29.4095L139.613 28.4196L131.693 20.5881Z"
                fill="#3B3B3B"
            />
            <path
                d="M121.531 31.9087C121.531 29.6602 123.354 27.8374 125.603 27.8374H157.834C160.082 27.8374 161.905 29.6602 161.905 31.9087V41.0634H121.531V31.9087Z"
                fill="white"
            />
            <path
                d="M124.603 40.9817H129.79V41.038C129.79 41.7758 129.192 42.3739 128.454 42.3739H125.938C125.201 42.3739 124.603 41.7758 124.603 41.038V40.9817Z"
                fill="#3B3B3B"
            />
            <path
                d="M153.524 40.9817H158.712V41.038C158.712 41.7758 158.113 42.3739 157.376 42.3739H154.86C154.123 42.3739 153.524 41.7758 153.524 41.038V40.9817Z"
                fill="#3B3B3B"
            />
            <path
                d="M128.779 32.8512C128.779 31.9594 129.502 31.2366 130.393 31.2366H152.452C153.344 31.2366 154.067 31.9594 154.067 32.8512V36.3655C154.067 37.2572 153.344 37.9801 152.452 37.9801H130.393C129.502 37.9801 128.779 37.2572 128.779 36.3655V32.8512Z"
                fill="#3B3B3B"
            />
            <circle cx="133.759" cy="34.8247" r="1.5" fill="#FDC2B2" />
            <circle cx="139.876" cy="34.8247" r="1.5" fill="#FDC2B2" />
            <circle cx="145.993" cy="34.8247" r="1.5" fill="#FDC2B2" />
            <circle cx="152.11" cy="34.8247" r="1.5" fill="#FDC2B2" />
            <circle cx="158.227" cy="34.8247" r="1.5" fill="#FDC2B2" />
            <path
                d="M185.163 42.374H100.935C99.397 42.374 98.1504 43.6206 98.1504 45.1584C98.1504 46.6962 99.397 47.9428 100.935 47.9428H185.163V42.374Z"
                fill="#F2DEC3"
            />
            <ellipse
                cx="12.0315"
                cy="12.0825"
                rx="12.0315"
                ry="12.0825"
                transform="matrix(-0.893905 0.448257 0.443245 0.896401 77.0671 17.678)"
                fill="#3B3B3B"
            />
            <path
                d="M58.6254 23.2487C57.4009 23.1037 56.4814 24.3458 56.969 25.4862L59.7599 32.0134L65.634 24.0783L58.6254 23.2487Z"
                fill="#3B3B3B"
            />
            <path
                d="M78.3746 19.2269C78.0384 18.0297 76.5329 17.6457 75.6715 18.5376L70.4904 23.901L80.3964 26.4271L78.3746 19.2269Z"
                fill="#3B3B3B"
            />
            <path d="M69.4212 33.2649L65.4682 33.3936" stroke="white" strokeWidth="1.60812" strokeLinecap="round" />
            <path d="M76.7894 29.2032L73.5877 31.5416" stroke="white" strokeWidth="1.60812" strokeLinecap="round" />
            <path
                d="M74.0378 35.9213C74.1925 34.8863 73.2345 34.0369 72.2274 34.3163C71.2203 34.5957 70.8292 35.8193 71.4884 36.6285L71.9315 37.1724C72.2152 37.5206 72.6778 37.6678 73.1112 37.5475C73.5447 37.4273 73.8672 37.0624 73.9338 36.6169L74.0378 35.9213Z"
                fill="#FDC2B2"
            />
            <path
                d="M101.557 22.1164C103.056 23.4442 103.204 25.7421 101.887 27.2491L86.762 44.5618L81.3351 39.7536L96.46 22.4409C97.7766 20.934 100.059 20.7887 101.557 22.1164Z"
                fill="#3B3B3B"
            />
            <ellipse
                cx="1.8054"
                cy="1.81779"
                rx="1.8054"
                ry="1.81779"
                transform="matrix(-0.997983 0.0625025 -0.0616426 -0.99816 103.866 26.8972)"
                fill="#3B3B3B"
            />
            <ellipse
                cx="1.8054"
                cy="1.81779"
                rx="1.8054"
                ry="1.81779"
                transform="matrix(-0.997983 0.0625025 -0.0616426 -0.99816 103.184 24.6455)"
                fill="#3B3B3B"
            />
            <ellipse
                cx="1.8054"
                cy="1.81779"
                rx="1.8054"
                ry="1.81779"
                transform="matrix(-0.997983 0.0625025 -0.0616426 -0.99816 100.806 24.2119)"
                fill="#3B3B3B"
            />
            <path
                d="M98.9807 40.3399C100.544 41.611 100.79 43.9159 99.5298 45.4881L85.0508 63.5509L79.3887 58.9481L93.8677 40.8853C95.128 39.3131 97.4172 39.0689 98.9807 40.3399Z"
                fill="#3B3B3B"
            />
            <ellipse
                cx="1.81747"
                cy="1.82998"
                rx="1.81747"
                ry="1.82998"
                transform="matrix(-0.994468 0.105041 -0.103593 -0.99462 101.337 45.0525)"
                fill="#3B3B3B"
            />
            <ellipse
                cx="1.81747"
                cy="1.82998"
                rx="1.81747"
                ry="1.82998"
                transform="matrix(-0.994468 0.105041 -0.103593 -0.99462 100.556 42.8171)"
                fill="#3B3B3B"
            />
            <ellipse
                cx="1.81747"
                cy="1.82998"
                rx="1.81747"
                ry="1.82998"
                transform="matrix(-0.994468 0.105041 -0.103593 -0.99462 98.1465 42.4827)"
                fill="#3B3B3B"
            />
            <path
                d="M62.9511 50.6776C63.1609 43.6368 68.9291 38.0378 75.9731 38.0378C83.1681 38.0378 89.0008 43.8705 89.0008 51.0656V86.046C89.0008 93.5287 82.9349 99.5946 75.4522 99.5946C67.8114 99.5946 61.682 93.2799 61.9095 85.6426L62.9511 50.6776Z"
                fill="#3B3B3B"
            />
            <path
                d="M36.7745 64.1716L38.3468 62.6821C46.0628 55.3723 58.4955 63.0098 55.5333 73.24V73.24C53.9912 78.5658 56.8728 84.186 62.0966 86.0406L65.7516 87.3382"
                stroke="#3B3B3B"
                strokeWidth="5.59468"
                strokeLinecap="round"
            />
            <ellipse
                cx="13.1399"
                cy="13.1952"
                rx="13.1399"
                ry="13.1952"
                transform="matrix(-0.892798 0.450457 0.445433 0.895315 83.1226 68.2012)"
                fill="#3B3B3B"
            />
            <path
                d="M70.6626 92.2085H90.8085C92.8483 92.2085 94.5019 93.8621 94.5019 95.9019C94.5019 97.9417 92.8483 99.5953 90.8085 99.5953H72.3654C71.425 99.5953 70.6626 98.8329 70.6626 97.8925V92.2085Z"
                fill="#3B3B3B"
            />
            <path
                d="M79.1717 72.6786C79.2144 72.3155 79.5442 72.0541 79.9043 72.1157C82.105 72.4923 84.1779 73.429 85.9238 74.8414C87.842 76.3934 89.2882 78.4572 90.0974 80.7973C90.9066 83.1374 91.046 85.6594 90.4999 88.0755C90.0027 90.2748 88.9557 92.3056 87.463 93.9774C87.2194 94.2503 86.7985 94.2506 86.5404 93.9921C86.2848 93.736 86.2855 93.3224 86.5255 93.0509C87.8486 91.5546 88.7773 89.7428 89.2205 87.7822C89.712 85.6077 89.5865 83.3379 88.8583 81.2318C88.13 79.1257 86.8284 77.2683 85.102 75.8716C83.5469 74.6135 81.7037 73.7748 79.7459 73.4291C79.3876 73.3658 79.1292 73.0402 79.1717 72.6786Z"
                fill="white"
            />
            <path
                d="M129.097 12.5724C128.554 12.261 128.361 11.567 128.708 11.0463C129.995 9.1153 131.697 7.49341 133.693 6.30391C136.013 4.92155 138.651 4.17079 141.346 4.12547C144.042 4.08016 146.703 4.74186 149.067 6.04547C151.101 7.16718 152.856 8.73091 154.206 10.6175C154.571 11.1263 154.401 11.8264 153.869 12.1558C153.333 12.4879 152.633 12.3169 152.259 11.809C151.121 10.2627 149.661 8.97873 147.976 8.04979C145.957 6.93682 143.685 6.37189 141.384 6.41057C139.083 6.44926 136.831 7.09024 134.85 8.27044C133.197 9.2556 131.78 10.5882 130.694 12.172C130.337 12.692 129.643 12.8862 129.097 12.5724Z"
                fill="#FDC2B2"
            />
            <path
                d="M134.436 14.8594C133.996 14.5991 133.845 14.0289 134.145 13.6147C134.909 12.5583 135.886 11.6708 137.015 11.0118C138.411 10.1975 139.991 9.75977 141.604 9.7411C143.217 9.72243 144.808 10.1234 146.221 10.9052C147.365 11.5379 148.362 12.4026 149.151 13.4409C149.46 13.8481 149.322 14.4217 148.888 14.6921C148.451 14.9646 147.879 14.8247 147.557 14.4224C146.944 13.6577 146.188 13.0181 145.327 12.5422C144.194 11.9154 142.919 11.5938 141.626 11.6088C140.333 11.6238 139.065 11.9747 137.946 12.6276C137.097 13.1233 136.355 13.7804 135.76 14.5592C135.447 14.9688 134.879 15.1218 134.436 14.8594Z"
                fill="#FDC2B2"
            />
            <path d="M141.821 2.04834L141.821 14.5782" stroke="#FC6538" strokeWidth="3.0301" strokeLinecap="round" />
            <ellipse
                cx="2.07511"
                cy="2.08831"
                rx="2.07511"
                ry="2.08831"
                transform="matrix(-1 0 0 1 143.931 16.4658)"
                fill="#FC6538"
            />
        </svg>
    );
};
